// Single company selection shared by every Field Configuration page.
export const SELECTED_COMPANY_KEY = "fieldConfig_selectedCompany";

export function getSelectedCompanyUuid() {
  try {
    return localStorage.getItem(SELECTED_COMPANY_KEY) || "";
  } catch (e) {
    return "";
  }
}

export function setSelectedCompanyUuid(uuid) {
  try {
    localStorage.setItem(SELECTED_COMPANY_KEY, uuid || "");
  } catch (e) {
    // Storage unavailable; selection just won't persist.
  }
}
